import React, { useEffect, useMemo, useState } from "react";
import { request } from "../../../../utils/request";
import Select from "react-select";

const Insumos = ({insumos, onChange, errors, disabled}) => {
    const [insumoOptions, setInsumoOptions] = useState([]);

    const getInsumosOptions = async () => {
        const response = await request('salud/insumos');

        setInsumoOptions((response.data ?? []).map((item) => ({value: item.id, label: item.nombre})));
    };

    const setProp = (value, index) => {
        onChange([
            ...insumos.slice(0, index),
            {...insumos[index], ...value},
            ...insumos.slice(index + 1),
        ]);  
    };

    const remover = (index) => {
        onChange([
            ...insumos.slice(0, index),
            ...insumos.slice(index + 1),
        ]); 
    };

    const agregarNuevo = () => {
        onChange([
            ...insumos,
            {},
        ]);
    };

    useEffect(() => {
        getInsumosOptions();
    }, []);

    return <>
        <div className="form-group">
            <label>Insumos Médicos</label>

            {insumos.map((insumo, index) => <div className="row mb-2" key={insumo.id ?? index}>
                <div className="col-9">
                    <Select
                        key="id"
                        name='id'
                        isClearable
                        isDisabled={disabled}
                        placeholder='Seleccionar...'
                        options={insumoOptions}
                        value={insumo.id ? {value: insumo.id, label: insumo.nombre} : null}
                        onChange={({value: id, label: nombre }) => {
                            setProp({ id, nombre }, index);
                        }}
                    />

                    {errors[`insumos.${index}.id`] && (
                        <small className='help-blockParams form-Text'>
                            {errors[`insumos.${index}.id`]}
                        </small>
                    )}
                </div>

                <div className="col">
                    <input
                        className="form-control"
                        type="number"
                        step={0.01}
                        min={0}
                        name="cantidad"
                        value={insumo.cantidad}
                        onChange={e => setProp({ cantidad: e.target.value }, index)}
                        disabled={disabled}
                    />

                    {errors[`insumos.${index}.cantidad`] && (
                        <small className='help-blockParams form-Text'>
                            {errors[`insumos.${index}.cantidad`]}
                        </small>
                    )}
                </div>

                <button className="btn btn-danger ml-auto mr-3" onClick={() => remover(index)}>
                    <i className="fas fa-minus"></i>
                </button>
            </div>)}

            <div className="row">
                <button className="btn ml-auto mr-3" onClick={agregarNuevo}>
                    + Agregar Insumo
                </button>
            </div>
        </div>
    </>;
};

export default Insumos;